export default __webpack_public_path__ + "static/media/chevrons-right-dark.4c04903f.svg";